<template>
    <div>
        <span>{{ value }}</span>
        <span> lx</span>
    </div>
</template>
<script>
export default {
    props: ['profile', 'value']
};
</script>
